import React from 'react'
import SimpleHistoricalAssessment from "../../simpleHistoricalAssessment"
import Content from '../content'
import { useProjectContext } from "../../../contexts/projectContext"

const DefaultLayout = ({ ContentComponent = Content }) => {
  const { project } = useProjectContext()

  return (
    <div className="max-w-[978px]">
      <SimpleHistoricalAssessment project={ project }/>
    </div>
  )
}

export default DefaultLayout
